import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddPaymentDialogComponent } from './add-payment-dialog/add-payment-dialog.component';
import { PaypointService } from '../../services/paypoint.service';
import { PaymentMethodResponse } from '../../models/payment-method-response.interface';
import { take } from 'rxjs/operators';
import { SelectAnotherDefaultMethodComponent } from './select-another-default-method/select-another-default-method.component';
import { RemoveConfirmationDialogComponent } from './remove-confirmation-dialog/remove-confirmation-dialog.component';
import { LayoutUtility } from '../../../../shared/utils';

@Component({
  selector: 'kt-bridgepay-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.scss'],
})
export class WalletComponent implements OnInit {
  @Input() customerId: string;
  @Input() organization: string;
  paymentMethods: PaymentMethodResponse[] = [];
  creditCards: PaymentMethodResponse[] = [];
  bankAccounts: PaymentMethodResponse[] = [];
  notDefaultCards = [];

  constructor(
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private layoutUtility: LayoutUtility,
    private paypointService: PaypointService,
  ) {}

  ngOnInit(): void {
    this.loadPaymentMethods();
  }

  loadPaymentMethods(): void {
    this.paymentMethods = [];
    this.paypointService
      .getPaymentMethods(this.organization, this.customerId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.paymentMethods = response.data;
          this.creditCards = this.paymentMethods.filter(
            (paymentMethod) => paymentMethod.type === 'card',
          );
          this.bankAccounts = this.paymentMethods.filter(
            (paymentMethod) => paymentMethod.type === 'ach',
          );
          this.cd.detectChanges();
        },
        error: () => {
          // TODO: Handle error gracefully
        },
        complete: () => {
          this.cd.detectChanges();
        },
      });
  }

  openAddPaymentDialog(): void {
    const dialogRef = this.dialog.open(AddPaymentDialogComponent, {
      width: '600px',
      height: '600px',
      data: {
        customerId: this.customerId,
        organization: this.organization,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.ngOnInit();
      this.loadPaymentMethods();
    });
  }
  setDefault(method: PaymentMethodResponse): void {
    this.paypointService
      .setDefaultPaymentMethod(this.organization, this.customerId, method.payment_method_code)
      .subscribe({
        next: () => {
          this.loadPaymentMethods();
          this.layoutUtility.showActionNotification('SUCCESS', 'Primary card changed successfully');
        },
      });
  }

  getCardExpiry(method: PaymentMethodResponse): string {
    return `${method.token_data.data.card?.expiration_month}/${method.token_data.data.card?.expiration_year}`;
  }

  // selectMethod(method: PaymentMethodResponse): void {
  //   this.selectedMethod = method;
  //   this.methodSelected.emit(method);
  // }

  getHolderName(method: PaymentMethodResponse): string {
    if (method.type === 'card') {
      return `${method.token_data?.data?.data?.name || 'Unknown'}`;
    }
  }

  getMaskedNumber(method: PaymentMethodResponse): string {
    if (method.type === 'card') {
      return `•••• •••• •••• ${method.token_data.data.card?.last4}`;
    }
    if (method.type === 'ach') {
      return `•••• •••• •••• ${method.token_data.data.bank?.account_number_last4}`;
    }
  }
  getBankName(method: PaymentMethodResponse): string {
    if (method.type === 'ach') {
      return `${method.token_data.data.data?.bank_name}`;
    }
  }
  getAccountName(method: PaymentMethodResponse): string {
    if (method.type === 'ach') {
      return `${method.token_data.data.data?.account_name}`;
    }
  }

  openRemoveDialog(method: PaymentMethodResponse): void {
    const dialog: any =
      method?.is_default && this.creditCards?.length > 1
        ? SelectAnotherDefaultMethodComponent
        : RemoveConfirmationDialogComponent;
    let data = {
      method,
      organization: this.organization,
      customerId: this.customerId,
      notDefaultCards: this.notDefaultCards,
    };
    if (method.is_default && this.creditCards?.length > 1) {
      this.notDefaultCards = this.creditCards.filter((card) => !card.is_default);
      data = {
        method,
        organization: this.organization,
        customerId: this.customerId,
        notDefaultCards: this.notDefaultCards,
      };
    }
    const openedDialog = this.dialog.open(dialog, {
      width: '500px',
      data,
    });
    openedDialog.afterClosed().subscribe(() => {
      this.loadPaymentMethods();
    });
  }
}
